import ActionsForm from '@/shared/mixins/actionsForm'
import aprTemplateRiskTypeRepository from '@/shared/http/repositories/business/aprTemplateRiskType'
import { toast, loading } from '@/shared/utils/UIHelper'

// import Tools from '@/components/tools/Tools'

export default {
  name: 'addEpiApr',
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      cancelaRisco: false,
      formAddRisco: {
        risco: null
      },
      dataTipoRiscos: [],
      dataRisco: null

    }
  },

  props: ['aprId', 'revisao', 'etapaServicoId'],

  watch: {
  },

  mounted () {
  },
  methods: {
    cancel () {
      this.cancelaRisco = !this.cancelaRisco
      this.$emit('cancelaRiscos', this.cancelaRisco)
    },
    onLoad () {
      loading.push()
      aprTemplateRiskTypeRepository.GetRiscos(this.aprId, this.revisao, this.etapaServicoId)
        .then((Response) => {
          loading.pop()
          this.dataTipoRiscos = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    SalvaRisco () {
      if (this.formAddRisco.risco != null && this.formAddRisco.risco !== undefined) {
        let dataRisco = {colorStatusAPR: 'rgb(128 128 128)', emMemoria: true, id: null, etapaServico: this.etapaServicoId, revisao: null, riscoId: this.formAddRisco.risco.id, riscoDescricao: this.formAddRisco.risco.descricao, dataCriacaoRisco: null, itens: []}
        this.$emit('NovoRisco', dataRisco)
      } else {
        toast.warning('Selecione um risco')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/addAprRisk/addAprRisk.js